import { useCustom } from '@refinedev/core';

export type PublicTenantConfig = {
  authMethod: 'password' | 'sso_only';
};

export const usePublicTenantConfig = (tenantName: string | undefined) => {
  const { data, isLoading, isError, error } = useCustom<PublicTenantConfig>({
    url: `public/tenant-config/${encodeURIComponent(tenantName ?? '')}`,
    method: 'get',
    queryOptions: {
      enabled: !!tenantName,
      retry: false,
    },
  });

  return {
    config: data?.data ?? { authMethod: 'password' as const },
    isLoading,
    isError,
    error,
  };
};
